import type { ActionParams } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import { dispatch } from '@swf/core/store';

import defaultHeaderImg from '../../assets/images/default-header.png';
import FixedPrizeDrawBack from '../../components/FixedPrizeDraw/FixedPrizeDrawBack';
import FixedPrizeDrawFront from '../../components/FixedPrizeDraw/FixedPrizeDrawWon';
import { ActionType } from '../../enums';

import {
  TXTCLI_Close,
  TXTWCL_Check_the_Prizes,
  TXTWCL_CongratulationsX_you_won_a_pri_ELL,
  TXTWCL_Winners
} from './FixedPrizeDraw.Won.messages.json';

export default {
  front: {
    view: FixedPrizeDrawFront,
    viewConfig: {
      title: {
        tag: TXTWCL_CongratulationsX_you_won_a_pri_ELL,
        values: { 0: 'drawName' }
      },
      defaultHeaderImageURL: defaultHeaderImg,
      showCloseIcon: true,
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: { tag: TXTCLI_Close },
          actionFunction: ({ notificationId }: ActionParams) => {
            dispatch.notification.delete({ notificationId });
            dispatch.modal.close('/mpnotifications');
          }
        },
        {
          actionType: ActionType.Secondary,
          actionLabel: { tag: TXTWCL_Check_the_Prizes },
          actionFunction: () => {
            /* handled in NotificationComponent secondary action */
          }
        }
      ]
    }
  },
  back: {
    view: FixedPrizeDrawBack,
    viewConfig: {
      title: { tag: TXTWCL_Winners }
    }
  }
};
